/**
 * All of the possible document types.
 */
export enum DocumentType {
    FAIR = 'First Article Inspection Report (FAIR)',
    COC = 'Certificate of Conformance',
    IDIAMOND = 'Process Control Inspection Report/i-Diamond Report',
    CSP = 'Critical Safety Parts',
    REACH = 'RoHS And REACH Declaration',
    RFQ = 'Request For Quotation',
    ADDITIONAL = 'Miscellaneous Documents'
}
